import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

// .then wrapper is needed because the barrel exports named exports, not a default
const RecorderV1Lazy = React.lazy(() =>
    import("@kaltura/mediaspace-shared-recorder").then((m) => ({ default: m.Recorder }))
);
const RecorderV2Lazy = React.lazy(() =>
    import("@kaltura/mediaspace-shared-recorder").then((m) => ({ default: m.RecorderV2 }))
);

// Page renderers — used by record.phtml to mount into a DOM container
export const RecorderV1 = getDsLayoutComponentRenderer(RecorderV1Lazy);
export const RecorderV2 = getDsLayoutComponentRenderer(RecorderV2Lazy);

// React components — used by CustomComponent (BSE / AddToCategory creation tools)
export const RecorderV1Component = RecorderV1Lazy;
export const RecorderV2Component = RecorderV2Lazy;
